export default __webpack_public_path__ + "static/kombi-white-968bf20067c065c8c7e91e6ad5b03051.svg";